import { Box, Chip, Tooltip } from '@mui/material';
import { useLabelChips } from './useLabelChips';
import { LabelChipsProps } from './types';
import './LabelChips.scss';

export const LabelChips = (props: LabelChipsProps) => {
  const { formattedLabels, handleChipDelete } = useLabelChips(props);

  // Empty state: render nothing
  if (formattedLabels.length === 0) {
    return null;
  }

  return (
    <Box className="labelChipsContainer">
      {formattedLabels.map(label => (
        <Tooltip key={label.id} title={label.value} arrow>
          <Chip
            label={label.value}
            color="primary"
            size="small"
            variant="filled"
            onDelete={() => handleChipDelete(label.id)}
            className="labelChip"
          />
        </Tooltip>
      ))}
    </Box>
  );
};
